import React from "react";
import { vars } from "@seed-design/design-token";
import { basicRendererPlugin } from "@stackflow/plugin-renderer-basic";
import { basicUIPlugin } from "@stackflow/plugin-basic-ui";
import { historySyncPlugin } from "@stackflow/plugin-history-sync";
import { stackflow } from "@stackflow/react";
import { preloadPlugin } from "@stackflow/plugin-preload";

import { preloadDataMap } from "./lib/readPreloadData";

declare const window: any;

const activities = {
  Index: React.lazy(() => import("./activities/Index")),
  Hotcake: React.lazy(() => import("./activities/Hotcake")),
};

const theme =
  typeof window !== "undefined" &&
  /iphone|ipad|ipod/i.test(navigator.userAgent.toLowerCase())
    ? "cupertino"
    : "android";

const borderColor =
  theme === "cupertino"
    ? vars.$semantic.color.divider3
    : vars.$semantic.color.divider2;

export const { Stack, useFlow } = stackflow({
  transitionDuration: 350,
  activities,
  plugins: [
    basicRendererPlugin(),
    basicUIPlugin({
      theme,
      backgroundColor: vars.$semantic.color.paperDefault,
      appBar: {
        borderColor,
        textColor: vars.$semantic.color.inkText,
        iconColor: vars.$semantic.color.inkText,
      },
    }),
    historySyncPlugin({
      routes: {
        Index: "/",
        Hotcake: "/:uid/",
      },
      fallbackActivity: () => "Index",
    }),
    preloadPlugin({
      loaders: {
        Hotcake({
          activityParams,
          isInitialActivity,
          initialContext,
          activityContext,
        }) {
          const key = `Hotcake#${JSON.stringify(activityParams)}` as string;

          if (isInitialActivity) {
            preloadDataMap[key] = {
              _t: "ok",
              data: (initialContext as any).data,
            };
          }

          if (!preloadDataMap[key]) {
            const promise = window.___loader
              .loadPage((activityContext as any).path)
              .then(
                (result: any) =>
                  (preloadDataMap[key] = {
                    _t: "ok",
                    data: result.json.data,
                  })
              );

            preloadDataMap[key] = {
              _t: "pending",
              promise,
            };
          }

          return {
            key,
          };
        },
      },
    }),
  ],
});

export type TypeActivities = typeof activities;
export type TypeUseFlow = typeof useFlow;
